// 巴士通知
import Vue from 'vue'
export const EventBus = new Vue()
